// SPDX-License-Identifier: Apache-2.0
export enum SelectionTool {
  Point,
  Polygon,
  Rectangle,
  Disk,
  FreehandPolygon
}

export enum SelectionMode {
  Replace,
  Add,
  Remove
}
